<template>
  <div class="pa-2" style="width: 50%">
    <RichText
      class="mb-4"
      :model-value="plan?.context_general_information ?? ''"
      :diff-value="diffPlan?.context_general_information"
      label="3.1 Context & General Information"
      readonly
      :options="{ diff }"
    />

    <v-card class="mb-4" variant="outlined" rounded="lg">
      <v-toolbar density="compact">
        <v-toolbar-title>3.2 Boundary Limits</v-toolbar-title>
      </v-toolbar>
      <v-table fixed-header density="compact" class="boundary-limits-table">
        <thead>
          <tr>
            <th class="text-left">Functional Location</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in plan?.floc_boundaries ?? []" :key="item.id">
            <td>{{ item.functional_location.functional_location }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <v-card variant="outlined" rounded="lg">
      <v-toolbar density="compact">
        <v-toolbar-title>3.3 Boundary Limits Tree</v-toolbar-title>
      </v-toolbar>
      <FunctionalLocationTree
        ref="flocTree"
        :tree-items="sortedTreeItems"
        max-height="500px"
        @view="flocDialog?.open($event.item.id)"
      />
      <FunctionalLocationDialog ref="flocDialog" readonly />
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { AssetManagementPlan, FunctionalLocation } from "@/classes";
import RichText from "@/components/base/inputs/RichText.vue";
import FunctionalLocationDialog from "@/components/functional-location/FunctionalLocationDialog.vue";
import FunctionalLocationTree from "@/components/functional-location/tree/FunctionalLocationTree.vue";
import { TreeItem } from "@/components/functional-location/tree/tree";
import { computed, ref, watch } from "vue";

const props = defineProps<{
  plan: AssetManagementPlan | null;
  diffPlan?: AssetManagementPlan | null;
  diff?: boolean;
}>();

const flocTree = ref<InstanceType<typeof FunctionalLocationTree> | null>(null);
const flocDialog = ref<InstanceType<typeof FunctionalLocationDialog> | null>(
  null,
);

const treeItems = ref<TreeItem<FunctionalLocation>[]>([]);

// Display tree items in same order as boundary list
const sortedTreeItems = computed(() => {
  const items: TreeItem<FunctionalLocation>[] = [];
  if (props.plan) {
    props.plan.floc_boundaries.forEach((bound) => {
      const item = treeItems.value.find(
        (i) => i.item.id === bound.functional_location_id,
      );
      if (item) items.push(item);
    });
  }
  return items;
});

watch(
  () => props.plan?.id,
  async () => {
    if (props.plan) {
      const flocIds: string[] = [];
      for (const bound of props.plan.floc_boundaries) {
        const exist = treeItems.value.find(
          (item) => item.item.id === bound.functional_location_id,
        );
        if (!exist) flocIds.push(bound.functional_location_id);
      }
      const flocs = await FunctionalLocation.getTreeChildren({
        parent_id: null,
        floc_ids: flocIds,
      });
      for (const floc of flocs) {
        const item = {
          item: floc,
          expanded: false,
          children: null,
        } as TreeItem<FunctionalLocation>;
        treeItems.value.push(item);
      }
    }
  },
  { immediate: true },
);
</script>
